module.exports = __webpack_public_path__ + "media/images/close-call-dda9438f.svg";